var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLesoes(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8477 4.67836L13.278 2.24797C14.5201 1.00589 16.5336 1.00589 17.7748 2.24797L18.9331 3.4063C20.1752 4.64839 20.1752 6.66181 18.9331 7.90301L16.4771 10.359",
    stroke: "black",
    strokeWidth: 0.610275,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8108 16.0267L8.37958 18.4579C7.13749 19.7 5.12407 19.7 3.88287 18.4579L2.72453 17.2996C1.48245 16.0575 1.48245 14.0441 2.72453 12.8029L5.10556 10.4219",
    stroke: "black",
    strokeWidth: 0.610275,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.88178 2.24908L2.72299 3.40787C1.48125 4.64961 1.48125 6.66289 2.72299 7.90463L13.2774 18.459C14.5191 19.7008 16.5324 19.7008 17.7741 18.459L18.9329 17.3002C20.1747 16.0585 20.1747 14.0452 18.9329 12.8035L8.37855 2.24908C7.1368 1.00733 5.12353 1.00733 3.88178 2.24908Z",
    stroke: "black",
    strokeWidth: 0.610275,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0739 6.90857L7.38477 9.59766L11.5125 13.7254L14.2016 11.0363L10.0739 6.90857Z",
    stroke: "black",
    strokeWidth: 0.610275,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7417 15.1377C13.8644 15.1377 13.9638 15.0382 13.9638 14.9155C13.9638 14.7928 13.8644 14.6934 13.7417 14.6934C13.619 14.6934 13.5195 14.7928 13.5195 14.9155C13.5195 15.0382 13.619 15.1377 13.7417 15.1377Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.610275,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3882 13.4912C15.5109 13.4912 15.6103 13.3917 15.6103 13.269C15.6103 13.1463 15.5109 13.0469 15.3882 13.0469C15.2655 13.0469 15.166 13.1463 15.166 13.269C15.166 13.3917 15.2655 13.4912 15.3882 13.4912Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.610275,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3882 16.7841C15.5109 16.7841 15.6103 16.6847 15.6103 16.562C15.6103 16.4393 15.5109 16.3398 15.3882 16.3398C15.2655 16.3398 15.166 16.4393 15.166 16.562C15.166 16.6847 15.2655 16.7841 15.3882 16.7841Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.610275,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0346 15.1377C17.1573 15.1377 17.2568 15.0382 17.2568 14.9155C17.2568 14.7928 17.1573 14.6934 17.0346 14.6934C16.912 14.6934 16.8125 14.7928 16.8125 14.9155C16.8125 15.0382 16.912 15.1377 17.0346 15.1377Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.610275,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.62254 6.01656C4.74522 6.01656 4.84468 5.9171 4.84468 5.79441C4.84468 5.67172 4.74522 5.57227 4.62254 5.57227C4.49985 5.57227 4.40039 5.67172 4.40039 5.79441C4.40039 5.9171 4.49985 6.01656 4.62254 6.01656Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.610275,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M6.26902 4.37007C6.39171 4.37007 6.49117 4.27062 6.49117 4.14793C6.49117 4.02524 6.39171 3.92578 6.26902 3.92578C6.14633 3.92578 6.04688 4.02524 6.04688 4.14793C6.04688 4.27062 6.14633 4.37007 6.26902 4.37007Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.610275,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M6.26902 7.66304C6.39171 7.66304 6.49117 7.56359 6.49117 7.4409C6.49117 7.31821 6.39171 7.21875 6.26902 7.21875C6.14633 7.21875 6.04688 7.31821 6.04688 7.4409C6.04688 7.56359 6.14633 7.66304 6.26902 7.66304Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.610275,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91551 6.01656C8.03819 6.01656 8.13765 5.9171 8.13765 5.79441C8.13765 5.67172 8.03819 5.57227 7.91551 5.57227C7.79282 5.57227 7.69336 5.67172 7.69336 5.79441C7.69336 5.9171 7.79282 6.01656 7.91551 6.01656Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.610275,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLesoes);
export default __webpack_public_path__ + "static/media/Lesoes.320b92ab4e84f1d3c22f3b1174833c07.svg";
export { ForwardRef as ReactComponent };